import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { find, get, isEmpty } from 'lodash';
import { Typography, MenuItem, Select } from '@material-ui/core';

import { Box, Dialog, Button } from 'components';
import { RootState } from 'redux-modules/store/rootState';
import { Deal } from 'redux-modules/deals/Types';
import {
  emptyInvestmentDataState,
  getInvestorDetails,
} from 'redux-modules/investor/Actions';
import { getInvestorDetail } from 'services';

import InvestNow from './InvestNow';
import styles from './styles';
import ReInvest from './ReInvest';

type Props = {
  spv: string;
  deal: any;
  isRolloverFromPortfolio?: boolean;
  reInvestPartial?: boolean;
  distributionData?: any;
};

const InvestNowDeal = ({
  spv,
  deal,
  isRolloverFromPortfolio = false,
  reInvestPartial = false,
  distributionData,
}: Props) => {
  const classes = styles();
  const dispatch = useDispatch();

  const { dealList, latestDeal } = useSelector(({ Deals }: RootState) => Deals);

  const [open, setOpen] = React.useState<boolean>(true);
  const [isRollover, setIsRollover] = React.useState<boolean>(
    isRolloverFromPortfolio,
  );
  const [openFilter, setOpenFilter] = React.useState<boolean>(false);
  const [renderInvestNow, setRenderInvestNow] = React.useState<boolean>(false);
  const [selectedSPV, setSelectedSPV] = React.useState<string>('');
  const [selectedDealId, setSelectedDealId] = React.useState<string>('');
  const [
    existingRolloverInvestment,
    setExistingRolloverInvestment,
  ] = React.useState<any>({});
  const [
    precheckExistingInvestment,
    setPrecheckExistingInvestment,
  ] = React.useState<boolean>(false);

  const handleFilterClose = () => {
    setOpenFilter(false);
  };
  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleDealChange = (dealId: string) => {
    setSelectedDealId(dealId);
    setSelectedSPV(get(find(dealList, { id: dealId }), 'deal', ''));
  };

  const handleClose = () => {
    if (!isEmpty(selectedSPV) && !isEmpty(selectedDealId)) {
      setOpen(false);
      setRenderInvestNow(true);
    }
  };

  useEffect(() => {
    dispatch(emptyInvestmentDataState());
  }, []);

  useEffect(() => {
    if (!isEmpty(spv) && !isEmpty(deal)) {
      setSelectedSPV(get(deal, 'deal', spv));
      setSelectedDealId(get(deal, 'id', ''));
      if (isRollover && !reInvestPartial) {
        setOpen(false);
        setRenderInvestNow(true);
      }
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(latestDeal) && isEmpty(spv) && isEmpty(deal)) {
      setSelectedSPV(get(latestDeal, 'deal', ''));
      setSelectedDealId(get(latestDeal, 'id', ''));
    }
  }, [latestDeal]);

  const handlePreCheckExistingInvestment = () => {
    setPrecheckExistingInvestment(true);
    getInvestorDetail()
      .then((data: any) => {
        const investments = get(data, 'investmentDetail') || [];

        if (!isEmpty(investments)) {
          const existingInvestment = investments.find(
            (item: any) => item.spv === selectedDealId,
          );

          if (
            !isEmpty(existingInvestment) &&
            get(existingInvestment, 'isRollover')
          ) {
            setExistingRolloverInvestment(existingInvestment);
            setIsRollover(true);
          }
        }
        handleClose();
      })
      .finally(() => {
        setPrecheckExistingInvestment(false);
      });
  };

  return (
    <Box>
      {!open &&
      renderInvestNow &&
      !isEmpty(selectedSPV) &&
      !isEmpty(selectedDealId) ? (
        !isRollover ? (
          <InvestNow
            selectedSPV={selectedSPV}
            selectedDealId={selectedDealId}
          />
        ) : (
          <ReInvest
            selectedSPV={selectedSPV}
            selectedDealId={selectedDealId}
            isRollover={isRollover}
            reInvestPartial={reInvestPartial}
            distributionData={
              isEmpty(distributionData)
                ? {
                    id: get(existingRolloverInvestment, 'id'),
                    balance:
                      get(existingRolloverInvestment, 'investmentAmount') -
                        parseFloat(
                          get(
                            existingRolloverInvestment,
                            'remainingWireAmount',
                          ),
                        ) || 0,
                    spv: {
                      id: get(existingRolloverInvestment, 'rolloverSpvId'),
                    },
                  }
                : distributionData
            }
          />
        )
      ) : (
        <Dialog
          open={open}
          maxWidth={'sm'}
          title={
            isRollover
              ? 'Select an SPV to roll-over remaining amount'
              : 'Select Deal'
          }
          buttonText="Submit"
          // handleClose={() => handleClose()}
          handleClose={(_: any, reason: any) => {
            if (reason && reason === 'backdropClick') return;
            // handleClose();
            handlePreCheckExistingInvestment();
            dispatch(getInvestorDetails());
          }}
          disableEscapeKeyDown
        >
          <Box className={classes.investDealBox}>
            <Box className={classes.investDealTxtBox}>
              {/* You are investing in 8vdX SPV for YC {spv || get(deal, 'deal')}. */}
              <Typography className={classes.investDealTxt}>
                You are investing in{' '}
              </Typography>
              <Select
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                open={openFilter}
                onClose={handleFilterClose}
                onOpen={handleFilterOpen}
                name="Investment"
                value={selectedDealId}
                displayEmpty
                onChange={(event: any) => {
                  handleDealChange(event.target.value);
                }}
                className={classes.selectBox}
              >
                {dealList
                  .filter((deal: Deal) => !deal.closed)
                  .map((deal: Deal) => (
                    <MenuItem value={get(deal, 'id')} key={get(deal, 'id')}>
                      SPV {get(deal, 'deal')}
                    </MenuItem>
                  ))}
              </Select>
            </Box>
            <Button
              className={classes.continueBtnBox}
              name="Continue"
              isLoading={precheckExistingInvestment}
              onClick={() => {
                handlePreCheckExistingInvestment();
                dispatch(getInvestorDetails());
              }}
            />
          </Box>
        </Dialog>
      )}
    </Box>
  );
};
export default InvestNowDeal;
